<template>
    <div id="page">
        <div class="page-content">
            <div class="fixed-top-box">
                <div class="page-title page-title-small">
                    <h2>
                        <!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
                        {{lableText('TaskType')??'نوع وظیفه'}}
                        <!--<button data-menu="HelpMenu" class="position-static"><i class="fa fa-question-circle helpIco"></i></button>-->
                    </h2>
                    <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                    <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
                </div>
                <div class="card header-card shape-rounded" data-card-height="100">
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                </div>
                <div class="card card-style mb-2">
                    <div class="p-3 d-flex">
                        <button id="filterBtn" type="button" class="btn btn-xs rounded-m brand-bg-color ml-1" data-toggle="modal" data-target="#searchModal" style="max-height:31px!important">
                            <i class="fa fa-filter text-white"></i>
                        </button>
                        <div class="filter-row-scrollable">

                        </div>
                    </div>
                </div>
            </div>

            <span data-menu="menu-language" class="optionMenu"></span>
            <div class="main-content-box-2">
                <div class="card card-style mb-2">
                    <div class="list-group list-custom-small list-icon-0">
                        <div class="list-group-div p-2" @click.prevent="openDetails(task.taskTypeId)" v-for="task in TaskTypeList" :key="task.taskTypeId">
                            <div class="py-3">
                                <i class="fa fa-check-circle color-blue2-dark"></i>
                                <span class="font-weight-bold">{{task.title}}</span>
                                <span class="float-left" @click.stop="showMenu(task.taskTypeId)" width="60px"><i class="fa fa-ellipsis-v float-left ml-0 font-14"></i></span>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="card card-style" v-if="TaskTypeList.length==0 && Loading==false">
                    <div class="content">
                        <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                        <p class="text-center py-3">هیچ موردی یافت نشد.</p>
                    </div>
                </div>
                <div class="card card-style" v-if="Loading==false && NoMoreData==false && TaskTypeList.length>0 && TaskTypeList.length%10==0">
                    <div class="content">
                        <div class="d-flex justify-content-center w-100">
                            <button class="btn btn-outline-info rounded-m" @click="GetNextPage">نمایش بیشتر</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn">
                <router-link to="/CreateTaskType">
                    <div class="icon icon-m rounded-m color-white bg-green2-light">
                        <i class="fa fa-plus"></i>
                    </div>
                </router-link>
            </div>
        </transition>

        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'CreateTaskType', params: { taskTypeId: selectedTypeId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>ویرایش</span><i class="fa fa-angle-left"></i></router-link>
                    <button @click="deleteTaskType" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <div id="searchModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header align-items-center">
                        <h4 class="modal-title mt-0">جستجو</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body m-0">
                        <div class="w-100 search-box rounded-m position-relative mb-3">
                            <i class="fa fa-search pr-3"></i>
                            <input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey">
                        </div>
                        <button type="button" class="btn btn-xxs mt-3 btn-full bg-green1-dark rounded-sm font-900 w-100" data-dismiss="modal" @click="filterList">
                            <i class="fa fa-search ml-2"></i>
                            جستجو
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <Help-Menu :title="pageTitle" keyEn="TaskList"></Help-Menu>

        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
            </div>
        </transition>
    </div>
</template>

<script>
    import VueSimpleAlert from 'vue3-simple-alert';
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu
        },
        data() {
            return {
                pageTitle: "",
                page: 1,
                filterId: 0,
                searchKey: "",
                selectedTypeId: 0,
                pageLoaded: false
            };
        },
        computed: {
            TaskTypeList() {
                return this.$store.getters.GetTaskTypeListForEdit;
            },
            NoMoreData() {
                return this.$store.getters.GetTaskTypeNoMoreData;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            }
        },

        created() {
            this.pageTitle = "راهنمای " + (this.lableText('TaskType') ?? 'نوع وظیفه');
            this.$store.dispatch("GetTaskTypeListForEditFromServer", {
                pageId: this.page,
                filterId: this.filterId,
                searchKey: this.searchKey
            });
        },
        methods: {
            showAddButton() {
                this.pageLoaded = true;
               
            },
            showMenu(taskTypeId) {
                this.selectedTypeId = taskTypeId;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            filterList() {
                this.page = 1;
                this.$store.dispatch("GetTaskTypeListForEditFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },
            deleteTaskType() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm("آیا مایل به حذف این نوع  هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.$http.get("Task/DeleteTaskType?id=" + this.selectedTypeId)
                        .then(data => {
                            var res = data.data.toString();
                            if (res === "1") {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                this.$router.go();

                            }
                            else {
                                this.showErrorMessage(res);
                            }


                        });
                });
            },
            openDetails(taskTypeId) {
                this.$router.push({ name: 'CreateTaskType', params: { taskTypeId: taskTypeId } });
                document.getElementsByClassName('menu-hider')[0].click();
            },
            GetNextPage() {
                this.page++;
                this.$store.dispatch("GetTaskTypeListForEditFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },
			pauseVid(id) {
				if (id != null) {
					var vid = document.getElementById(id);
					vid.pause();
				}
            },
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
        },
        mounted() {
            this.showAddButton();
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");

        }
    };
</script>
